/**
 * Extracts HTTP status code from error.
 * Checks error.statusCode which is the standard property from NestJS API responses.
 */
const getErrorStatus = (error: unknown): number | undefined => {
  if (!error || typeof error !== "object") return undefined;

  const err = error as { statusCode?: number };

  // Check error.statusCode (NestJS style errors from API)
  if (typeof err.statusCode === "number") return err.statusCode;

  return undefined;
};

/**
 * Extracts the message from an error, as the API's error body carries it.
 */
export const getErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== "object") return undefined;

  const err = error as { message?: unknown };

  return typeof err.message === "string" ? err.message : undefined;
};

/**
 * Checks if an error is a 401 Unauthorized error: the request had no valid token
 */
export const isUnauthenticatedError = (error: unknown): boolean =>
  getErrorStatus(error) === 401;

/**
 * Checks if an error is a 403 Forbidden or 404 Not Found error
 */
export const isNotFoundOrForbiddenError = (error: unknown): boolean => {
  const status = getErrorStatus(error);
  return status === 403 || status === 404;
};
